/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Dataroom2Inputs */

const en_coinvestments_nav_dataroom2 = /** @type {(inputs: Coinvestments_Nav_Dataroom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Room`)
};

/**
* | output |
* | --- |
* | "Data Room" |
*
* @param {Coinvestments_Nav_Dataroom2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_dataroom2 = /** @type {((inputs?: Coinvestments_Nav_Dataroom2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Dataroom2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_dataroom2(inputs)
});
export { coinvestments_nav_dataroom2 as "coInvestments_nav_dataRoom" }